const RoleTemplatePortalRoleLinkPermissionsBoiler = {
    hasRole: false,
    dropRole: false,
    addRole: false,
    hasEdit: false,
    dropEdit: false,
    addEdit: false,
    hasView: false,
    dropView: false,
    addView: false
}

export default RoleTemplatePortalRoleLinkPermissionsBoiler